import React, { useState, useEffect, useCallback } from 'react';
import { functions } from '../firebase/config';
import { httpsCallable } from 'firebase/functions';
import Header from '../components/Header';

const ManageDefaultCategoriesPage = ({ navigateTo, currentPage }) => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [newCategoryName, setNewCategoryName] = useState('');

    const fetchDefaultCategories = useCallback(async () => {
        setIsLoading(true); setError('');
        try {
            const getDefaultCategories = httpsCallable(functions, 'getDefaultCategories');
            const result = await getDefaultCategories();
            setCategories(result.data);
        } catch (err) { setError(err.message); } finally { setIsLoading(false); }
    }, []);

    useEffect(() => { fetchDefaultCategories(); }, [fetchDefaultCategories]);

    const handleAddCategory = async (e) => {
        e.preventDefault();
        if (!newCategoryName) return;
        try {
            await httpsCallable(functions, 'addDefaultCategory')({ name: newCategoryName });
            setNewCategoryName('');
            fetchDefaultCategories();
        } catch (err) { setError(err.message); }
    };

    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Are you sure you want to delete this default category for all users?")) return;
        try {
            await httpsCallable(functions, 'deleteDefaultCategory')({ categoryId });
            fetchDefaultCategories();
        } catch (err) { setError(err.message); }
    };

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-8">
            <Header title="Manage Default Categories" navigateTo={navigateTo} currentPage={currentPage} />
            <div className="bg-white p-6 rounded-lg shadow-md mb-8">
                <h2 className="text-xl font-semibold mb-4">Add a New Default Category</h2>
                <form onSubmit={handleAddCategory} className="flex items-center space-x-2">
                    <input type="text" value={newCategoryName} onChange={(e) => setNewCategoryName(e.target.value)} placeholder="New default category name" className="flex-grow px-3 py-2 border rounded-md" required />
                    <button type="submit" className="px-5 py-2 font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Add</button>
                </form>
                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-semibold mb-4">Default Category List</h2>
                {isLoading ? <p>Loading categories...</p> : (
                    <ul className="divide-y divide-gray-200">
                        {categories.map(cat => (
                            <li key={cat.id} className="py-3 flex justify-between items-center">
                                <span className="text-gray-800">{cat.name}</span>
                                <button onClick={() => handleDeleteCategory(cat.id)} className="text-red-500 hover:text-red-700 text-sm font-medium">Delete</button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ManageDefaultCategoriesPage;